/* eslint-disable react/prop-types */
import React, { Fragment } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { get } from 'lodash';
import * as colors from '../../config/colors';

const styles = StyleSheet.create({
  invoiceNoContainer: {
    flexDirection: 'row',
    marginTop: 15,
    justifyContent: 'flex-end',
  },
  invoiceDateContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  invoiceCancelContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  invoiceDate: {
    fontSize: 18,
    fontStyle: 'bold',
  },
  label: {
    // width: 60,
  },
  cancel: {
    width: '100%',
    fontSize: 18,
    fontStyle: 'bold',
    color: colors.errorColor,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

function InvoiceNo({ dados }) {
  const nomeFuncionario = get(dados, 'Funcionario.nome', '');
  const nomeCliente = get(dados, 'Cliente.nome', '');
  const nrViagem = get(dados, 'id', '0');
  const descricao = get(dados, 'descricao', '');
  const cancelamento = get(dados, 'cancelamento', null);
  return (
    <>
      <View style={styles.invoiceNoContainer}>
        <Text style={styles.label}>Viagem Nr:</Text>
        <Text style={styles.invoiceDate}>{nrViagem}</Text>
      </View>
      <View style={styles.invoiceDateContainer}>
        <Text style={styles.label}>Emissor: </Text>
        <Text>{nomeFuncionario}</Text>
      </View>
      <View style={styles.invoiceDateContainer}>
        <Text style={styles.label}>Cliente: </Text>
        <Text>{nomeCliente}</Text>
      </View>
      <View style={styles.invoiceDateContainer}>
        <Text style={styles.label}>Descrição: </Text>
        <Text>{descricao}</Text>
      </View>
      {cancelamento !== null && (
        <View style={styles.invoiceCancelContainer}>
          <Text style={styles.cancel}>*** CANCELADO ***</Text>
        </View>
      )}
    </>
  );
}

export default InvoiceNo;
